import styled from 'styled-components'

export const Chip = styled.span`
  color: #fff;
  background: ${(p) => p.theme.uiKit.colors.global.grey.grey500};
  display: inline-block;
  padding: 5px 10px;
  border-radius: 20px;
`
